import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToast,
  IonToolbar,
} from '@ionic/react';
import { copyOutline, keyOutline } from 'ionicons/icons';
import { useState } from 'react';

import type { VisibleOperatorPin } from '../lib/auth/sharedTabletOperatorApi.js';

export function OperatorPinModal(props: {
  value: VisibleOperatorPin | null;
  onDismiss: () => void;
}): JSX.Element {
  const [toast, setToast] = useState<string | null>(null);
  const generated = props.value && 'email_sent' in props.value ? props.value : null;

  async function copyPin(): Promise<void> {
    if (!props.value) return;
    try {
      await navigator.clipboard.writeText(props.value.pin);
      setToast('PIN copiato');
    } catch {
      setToast('Copia non riuscita: annota manualmente il PIN');
    }
  }

  return (
    <IonModal isOpen={!!props.value} onDidDismiss={props.onDismiss}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{generated ? 'PIN generato' : 'PIN operatore'}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={props.onDismiss}>Chiudi</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div style={{ maxWidth: 440, margin: '24px auto', textAlign: 'center' }}>
          <IonIcon icon={keyOutline} aria-hidden="true" style={{ fontSize: 44, color: '#0066cc' }} />
          <h2 style={{ color: '#0f172a', marginBottom: 6 }}>{props.value?.full_name}</h2>
          <p style={{ color: '#475569', fontSize: 14, lineHeight: 1.5 }}>
            {generated
              ? generated.email_sent
                ? 'Il PIN è stato inviato anche via email alla persona collegata.'
                : 'L’email non è stata inviata: consegna il codice solo alla persona interessata.'
              : 'Questo è il PIN attualmente valido. Mostralo soltanto alla persona interessata.'}
          </p>
          <div aria-label="PIN personale" style={{
            margin: '20px 0', padding: '18px 14px', borderRadius: 14,
            background: '#eff6ff', border: '1px solid #93c5fd', color: '#0f172a',
            fontSize: 34, fontWeight: 800, letterSpacing: '.28em', fontVariantNumeric: 'tabular-nums',
          }}>
            {props.value?.pin}
          </div>
          <IonButton expand="block" onClick={() => { void copyPin(); }} style={{ minHeight: 44 }}>
            <IonIcon icon={copyOutline} slot="start" />
            Copia PIN
          </IonButton>
          <IonButton expand="block" fill="outline" onClick={props.onDismiss} style={{ marginTop: 8, minHeight: 44 }}>
            Chiudi
          </IonButton>
        </div>
        <IonToast isOpen={!!toast} message={toast ?? ''} duration={2500} onDidDismiss={() => setToast(null)} />
      </IonContent>
    </IonModal>
  );
}
